import React from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';
import styled from 'styled-components';
import TYpography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';

import { useDynamicYieldValues } from '../../../../utils/dynamicYield';

const StyledList = styled(Box)`
  list-style-type: disc;
  padding-left: 20px;

  @media (width >= 1024px) {
    width: 1240px;
    padding-left: 0;
    padding-top: 40px;
    margin: 0 auto;
  }
`;

const StyledListItem = styled.li`
  margin-bottom: 18px;

  &:last-child {
    margin-bottom: 0;
  }

  @media (width >= 768px) {
    margin-bottom: 12px;
  }
`;

const StyledTypography = styled(TYpography)`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.01em;
  text-align: left;

  span {
    line-height: 23.76px;
    font-weight: 600;
  }
`;

const StyledLink = styled(Link)`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.01em;
  text-decoration: underline;
`;

function DisclaimerBox() {
  const { textTemplates } = useDynamicYieldValues();

  return (
    <StyledList tag="ul" marginTop={{ xs: '32px', lg: '60px' }}>
      <StyledListItem>
        <StyledTypography>
          <span>
            <sup>¹</sup>
            {' '}
            Cajita Turbo:
          </span>
          {' '}
          Valores calculados el
          <span>
            {` ${textTemplates.VALUES_CALCULATED_AT_CAJITA_TURBO}.`}
          </span>
          {' '}
          Monto mínimo de ahorro
          <span>{` ${textTemplates.MINIMUM_SAVINGS_AMOUNT}.`}</span>
          {' '}
          Vigencia al
          <span>{` ${textTemplates.VALID_UNTIL_CAJITA_TURBO}.`}</span>
        </StyledTypography>
      </StyledListItem>

      <StyledListItem>
        <StyledTypography>
          El rendimiento diario únicamente se genera sobre
          el saldo en la &quot;Cajita Turbo&quot; que tengas activada.
          Consulta
          {' '}
          <StyledLink
            href="/terminos-y-condiciones-cajita-turbo/"
            target="_blank"
            rel="noopener noreferrer"
            color="black"
          >
            Términos y Condiciones.
          </StyledLink>

        </StyledTypography>
      </StyledListItem>

      <StyledListItem>
        <StyledTypography>
          <sup>³</sup>
          <span>
            Ahorro Congelado |
            <sup> ²</sup>
            Cajitas:
          </span>
          {' '}
          Valores calculados el
          <span>
            {` ${textTemplates.VALUES_CALCULATED_AT}.`}
          </span>
          Vigencia al
          <span>{` ${textTemplates.VALID_UNTIL}.`}</span>
        </StyledTypography>
      </StyledListItem>

      <StyledListItem>
        <StyledTypography>
          <>
            Producto garantizado por el IPAB hasta por
            {' '}
            <span>400,000 UDIs.</span>
          </>
        </StyledTypography>
      </StyledListItem>

      <StyledListItem>
        <StyledTypography>

          <sup>³</sup>
          <span>
            Ahorro Congelado:
          </span>
          {' '}
          Monto mínimo de ahorro
          <span>{` ${textTemplates.FROZEN_MINIMUM_SAVINGS_AMOUNT} | `}</span>

          <span>
            {' '}
            <sup> ²</sup>
            Cajitas:
          </span>
          {' '}
          Monto mínimo de ahorro
          <span>{` ${textTemplates.MINIMUM_SAVINGS_AMOUNT}.`}</span>
        </StyledTypography>
      </StyledListItem>

      <StyledListItem>
        <StyledTypography>
          El rendimiento diario únicamente se genera sobre
          el saldo en cualquier &quot;Cajita&quot; que tengas activada.
          Consulta
          {' '}
          <StyledLink
            href="/rendimiento/terminosycondiciones"
            target="_blank"
            rel="noopener noreferrer"
            color="black"
          >
            Términos y Condiciones.
          </StyledLink>

        </StyledTypography>
      </StyledListItem>
      {(textTemplates.ADDITIONAL_DISCLAIMER_BULLETS ?? []).map(text => (
        <StyledListItem key={text}>
          <StyledTypography>{text}</StyledTypography>
        </StyledListItem>
      ))}
    </StyledList>
  );
}

export default DisclaimerBox;
